class GltheaaFeaturedNavigation extends HTMLElement {
  constructor() {
    super();
    this.hideTimer = null;
    this.onItemEnter = this.onItemEnter.bind(this);
    this.onPreviewEnter = this.onPreviewEnter.bind(this);
    this.onNavLeave = this.onNavLeave.bind(this);
    this.onPreviewLeave = this.onPreviewLeave.bind(this);
    this.onFocusIn = this.onFocusIn.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.desktopQuery = window.matchMedia('(min-width: 990px)');
  }

  connectedCallback() {
    this.nav = this.querySelector('.gltheaa-featured-nav__nav');
    this.items = this.querySelectorAll('.gltheaa-featured-nav__item');
    this.previews = this.querySelectorAll('.gltheaa-featured-nav__preview-item');
    this.previewMap = new Map();

    this.previews.forEach((preview) => {
      const blockId = preview.dataset.blockId;
      if (blockId) this.previewMap.set(blockId, preview);
    });

    this.items.forEach((item) => {
      item.addEventListener('mouseenter', this.onItemEnter);
      item.addEventListener('focusin', this.onFocusIn);
    });

    this.previews.forEach((preview) => {
      preview.addEventListener('mouseenter', this.onPreviewEnter);
      preview.addEventListener('mouseleave', this.onPreviewLeave);
    });

    this.nav?.addEventListener('mouseleave', this.onNavLeave);
    this.addEventListener('focusout', this.onFocusOut);
  }

  disconnectedCallback() {
    this.cancelHide();
    this.items?.forEach((item) => {
      item.removeEventListener('mouseenter', this.onItemEnter);
      item.removeEventListener('focusin', this.onFocusIn);
    });
    this.previews?.forEach((preview) => {
      preview.removeEventListener('mouseenter', this.onPreviewEnter);
      preview.removeEventListener('mouseleave', this.onPreviewLeave);
    });
    this.nav?.removeEventListener('mouseleave', this.onNavLeave);
    this.removeEventListener('focusout', this.onFocusOut);
  }

  getBlockId(item) {
    return item.dataset.blockId;
  }

  isDesktop() {
    return this.desktopQuery.matches;
  }

  isPreviewNode(node) {
    return Boolean(node?.closest?.('.gltheaa-featured-nav__preview-item'));
  }

  cancelHide() {
    if (!this.hideTimer) return;
    window.clearTimeout(this.hideTimer);
    this.hideTimer = null;
  }

  scheduleHide() {
    this.cancelHide();
    this.hideTimer = window.setTimeout(() => {
      this.clearActive();
      this.hideTimer = null;
    }, 150);
  }

  onItemEnter(event) {
    if (!this.isDesktop()) return;
    this.cancelHide();
    this.setActive(this.getBlockId(event.currentTarget));
  }

  onPreviewEnter(event) {
    if (!this.isDesktop()) return;
    this.cancelHide();
    this.setActive(this.getBlockId(event.currentTarget));
  }

  onNavLeave(event) {
    if (!this.isDesktop()) return;
    if (this.isPreviewNode(event.relatedTarget)) {
      this.cancelHide();
      return;
    }
    this.scheduleHide();
  }

  onPreviewLeave(event) {
    if (!this.isDesktop()) return;
    if (this.nav?.contains(event.relatedTarget)) return;
    if (this.isPreviewNode(event.relatedTarget)) return;
    this.scheduleHide();
  }

  onFocusIn(event) {
    if (!this.isDesktop()) return;
    const item = event.target.closest('.gltheaa-featured-nav__item');
    const preview = event.target.closest('.gltheaa-featured-nav__preview-item');
    const blockId = item ? this.getBlockId(item) : preview ? this.getBlockId(preview) : null;
    if (blockId) {
      this.cancelHide();
      this.setActive(blockId);
    }
  }

  onFocusOut(event) {
    if (!this.isDesktop()) return;
    if (this.contains(event.relatedTarget)) return;
    this.clearActive();
  }

  setActive(blockId) {
    if (!blockId) return;
    this.previews.forEach((preview) => {
      const isActive = preview.dataset.blockId === blockId;
      preview.classList.toggle('is-active', isActive);
      preview.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });
  }

  clearActive() {
    this.previews.forEach((preview) => {
      preview.classList.remove('is-active');
      preview.setAttribute('aria-hidden', 'true');
    });
  }
}

customElements.define('gltheaa-featured-navigation', GltheaaFeaturedNavigation);
